<app-modal [title]="data.type === 0 ? 'Edit profile picture' : 'Edit background picture'" (save)="save()" i18n-title>
  <p class="mat-body-2 gray-2" *ngIf="data.type === 0" i18n>This picture should be atleast 500x500px in size.</p>
  <p class="mat-body-2 gray-2" *ngIf="data.type === 1" i18n>This picture should be atleast 1920x640px in size.</p>

  <app-image-cropper (imageSelected)="imageChanges($event)" [currentImage]="data.currentImage"></app-image-cropper>
</app-modal>
